import CalendarCloseOutlinedSvg from 'assets/icons/close/CalendarCloseOutlined.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(CalendarCloseOutlinedSvg, {
  displayName: 'CalendarCloseOutlined',
});
